import React from "react";
import { Stack } from "@fluentui/react";
import { Card, Text, CardHeader } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "./CSS/QueueComponent.css";

const GeneralQueueComponent = ({ globalMetrics, globalAgentState }) => {
  const { t } = useTranslation();
  // Fonction pour formater les pourcentages et les durées
  const formatTime = (seconds) => {
    if (!seconds || seconds <= 0) return "00:00:00";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
  // Fonction pour formater les pourcentages
  const formatPercentage = (value) => {
    if (value == null || value === "--" || value === 0) return "--";
    // Convertir en nombre flottant
    const numberValue = parseFloat(value);
    // Si le nombre est entier, ne pas ajouter de chiffres après la virgule
    if (Number.isInteger(numberValue)) {
      return `${numberValue}%`;
    }

    // Sinon, fixer à deux chiffres après la virgule et supprimer les zéros inutiles
    const formattedValue = numberValue.toFixed(2).replace(/\.?0+$/, "");
    return `${formattedValue.replace(".", ",")}%`;
  };
  const formatPercentageOverflow = (value) => {
    if (value == null || value === "--" ) return "--";

    // Convertir en nombre flottant
    const numberValue = parseFloat(value);

    // Si le nombre est entier, ne pas ajouter de chiffres après la virgule
    if (Number.isInteger(numberValue)) {
      return `${numberValue}%`;
    }

    // Sinon, fixer à deux chiffres après la virgule et supprimer les zéros inutiles
    const formattedValue = numberValue.toFixed(2).replace(/\.?0+$/, "");

    return `${formattedValue.replace(".", ",")}%`;
  };
  return (
    <div className="general-queue-container ">
      <CardHeader
        className="card-header-General "
        description={t("QUEUES.QUEUE_NAME")}
      />

      <Stack
        horizontal
        tokens={{ childrenGap: 5, padding: 5 }}
        styles={{
          root: {
            paddingLeft: 16, // remplace par la valeur que tu veux
            paddingRight: 16,
          },
        }}
      >
        {Object.entries(globalAgentState)
          .sort(([stateA], [stateB]) => {
            const order = [
              "READY",
              "COFFEE BREAK",
              "ADMIN WORK",
              "OUT OF SHIFT",
            ];
            const indexA = order.indexOf(stateA);
            const indexB = order.indexOf(stateB);
            return (
              (indexA !== -1 ? indexA : 999) - (indexB !== -1 ? indexB : 999)
            );
          })
          .map(([state, count]) => {
            // Gestion dynamique des classes CSS

            const colorClass = "color-unified";

            // Gestion des libellés
            const labels = {
              "COFFEE BREAK": t("QUEUES.COFFEE_BREAK"),
              "ADMIN WORK": t("QUEUES.ADMIN_WORK"),
              READY: t("QUEUES.READY"),
              "OUT OF SHIFT": t("QUEUES.OUT_OF_SHIFT"),
            };
            const label = labels[state] || state; // Utiliser l’état brut s’il n’a pas de traduction

            return (
              <Card key={state} className={`agents-card ${colorClass}`}>
                <Text className="agents-card-text">{count}</Text>
                <Text className="agents-card-text">{label}</Text>
              </Card>
            );
          })}
      </Stack>
      <Stack
        styles={{
          root: {
            paddingLeft: 10, // remplace par la valeur que tu veux
            paddingRight: 10,
          },
        }}
        horizontal
        wrap
        tokens={{ childrenGap: 5, padding: 5 }}
      >
        {[
          {
            label: t("QUEUES.INSTANT_MESSAGING"),
            value: globalMetrics.todayChats || 0,
            extra: t("QUEUES.CALLS_CHATS_EXTRA_TODAY"),
          },
          {
            label: t("QUEUES.INSTANT_MESSAGING"),
            value: globalMetrics.tasksInQueue || 0,
            extra: t("QUEUES.CALLS_CHATS_EXTRA_LIVE"),
          },
          {
            label: t("QUEUES.SLA"),
            value: formatPercentage(globalMetrics.slaChat) || "--",
          },
          {
            label: t("QUEUES.AVERAGE_WAIT_TIME"),
            value: formatTime(globalMetrics.averageWaitTimeChat) || "00:00:00",
          },
          {
            label: t("QUEUES.MAX_WAIT_TIME"),
            value: formatTime(globalMetrics.longestWaitChat) || "00:00:00",
          },
        ].map((metric, index) => (
          <Card key={index} className="queue-card-chat">
            <Text className="queue-card-text">{metric.value}</Text>
            <Text
              className={`queue-card-extra ${
                metric.extra === "Live" ? "text-red" : "text-white"
              }`}
            >
              {metric.extra}
            </Text>
            <Text className="queue-card-text">{metric.label}</Text>
          </Card>
        ))}
      </Stack>
      <Stack
        styles={{
          root: {
            paddingLeft: 10, // remplace par la valeur que tu veux
            paddingRight: 10,
          },
        }}
        horizontal
        wrap
        tokens={{ childrenGap: 5, padding: 5 }}
      >
        {[
          {
            label: t("QUEUES.CALLS_IN_QUEUE"),
            value: globalMetrics.todayCalls || 0,
            extra: t("QUEUES.CALLS_CHATS_EXTRA_TODAY"),
          },
          {
            label: t("QUEUES.LIVE_CALLS"),
            value: globalMetrics.callsInQueue || 0,
            extra: t("QUEUES.CALLS_CHATS_EXTRA_LIVE"),
          },
          {
            label: t("QUEUES.ABANDON_RATE"),
            value: formatPercentage(globalMetrics.abandonRate) || "--",
          },
          {
            label: t("QUEUES.AVERAGE_WAIT_TIME"),
            value: formatTime(globalMetrics.averageWaitTime) || "00:00:00",
          },
          {
            label: t("QUEUES.MAX_WAIT_TIME"),
            value: formatTime(globalMetrics.longestWait) || "00:00:00",
          },
          {
            label: t("QUEUES.OVERFLOW"),
            value: formatPercentageOverflow(globalMetrics.overflowRate) ,
          },
          {
            label: t("QUEUES.SLA"),
            value: formatPercentage(globalMetrics.sla) || "--",
          },
        ].map((metric, index) => (
          <Card key={index} className="queue-card">
            <Text className="queue-card-text ">{metric.value}</Text>
            <Text
              className={`queue-card-extra ${
                metric.extra === t("QUEUES.CALLS_CHATS_EXTRA_LIVE")
                  ? "text-red"
                  : "text-white"
              }`}
            >
              {metric.extra}
            </Text>
            <Text className="queue-card-text">{metric.label}</Text>
          </Card>
        ))}
      </Stack>
    </div>
  );
};

export default GeneralQueueComponent;
